import { ArticleFilterI } from 'src/adminPanel/components/articleManagement/article/ArticleFilter';
import RequestArticle from 'src/adminPanel/entities/articleManagement/RequestArticle';
import RequestArticleImage from 'src/adminPanel/entities/articleManagement/RequestArticleImage';
import VendorArticleProductGroup from 'src/adminPanel/entities/articleManagement/VendorArticleProductGroup';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from 'src/store/actions';

/* Article - Article */
export const FETCH_ARTICLE_ARTICLE = 'FETCH_ARTICLE_ARTICLE';
export const REQUEST_ARTICLE_ARTICLE = 'REQUEST_ARTICLE_ARTICLE';
export const SUCCESS_ARTICLE_ARTICLE = 'SUCCESS_ARTICLE_ARTICLE';
export const FAILURE_ARTICLE_ARTICLE = 'FAILURE_ARTICLE_ARTICLE';

export const fetchArticleArticle = (
    pageable?: PageableQueryParams,
    articleFilter?: ArticleFilterI,
    excludeSetProducts?: boolean
) =>
    action(FETCH_ARTICLE_ARTICLE, {
        pageable,
        articleFilter,
        excludeSetProducts,
    });
export const requestArticleArticle = () => action(REQUEST_ARTICLE_ARTICLE);
export const requestArticleArticleSuccess = (response: any) => action(SUCCESS_ARTICLE_ARTICLE, { response });
export const requestArticleArticleFailure = (error: any) => action(FAILURE_ARTICLE_ARTICLE, { error });

export const UPDATE_ARTICLE_ARTICLE = 'UPDATE_ARTICLE_ARTICLE';
export const REQUEST_UPDATE_ARTICLE_ARTICLE = 'REQUEST_UPDATE_ARTICLE_ARTICLE';
export const SUCCESS_UPDATE_ARTICLE_ARTICLE = 'SUCCESS_UPDATE_ARTICLE_ARTICLE';
export const FAILURE_UPDATE_ARTICLE_ARTICLE = 'FAILURE_UPDATE_ARTICLE_ARTICLE';

export const updateArticleArticle = (requestArticle: RequestArticle) =>
    action(UPDATE_ARTICLE_ARTICLE, { requestArticle });
export const requestUpdateArticleArticle = () => action(REQUEST_UPDATE_ARTICLE_ARTICLE);
export const requestUpdateArticleArticleSuccess = (response: any) =>
    action(SUCCESS_UPDATE_ARTICLE_ARTICLE, { response });
export const requestUpdateArticleArticleFailure = (error: any) => action(FAILURE_UPDATE_ARTICLE_ARTICLE, { error });

export const DEACTIVATE_ARTICLE_ARTICLE = 'DEACTIVATE_ARTICLE_ARTICLE';
export const REQUEST_DEACTIVATE_ARTICLE_ARTICLE = 'REQUEST_DEACTIVATE_ARTICLE_ARTICLE';
export const SUCCESS_DEACTIVATE_ARTICLE_ARTICLE = 'SUCCESS_DEACTIVATE_ARTICLE_ARTICLE';
export const FAILURE_DEACTIVATE_ARTICLE_ARTICLE = 'FAILURE_DEACTIVATE_ARTICLE_ARTICLE';

export const deactivateArticleArticle = (articleId: string) => action(DEACTIVATE_ARTICLE_ARTICLE, { articleId });
export const requestDeactivateArticleArticle = () => action(REQUEST_DEACTIVATE_ARTICLE_ARTICLE);
export const requestDeactivateArticleArticleSuccess = (response: any) =>
    action(SUCCESS_DEACTIVATE_ARTICLE_ARTICLE, { response });
export const requestDeactivateArticleArticleFailure = (error: any) =>
    action(FAILURE_DEACTIVATE_ARTICLE_ARTICLE, { error });

/* Article - Article Assignment */
export const FETCH_ARTICLE_ARTICLE_ASSIGNMENT = 'FETCH_ARTICLE_ARTICLE_ASSIGNMENT';
export const REQUEST_ARTICLE_ARTICLE_ASSIGNMENT = 'REQUEST_ARTICLE_ARTICLE_ASSIGNMENT';
export const SUCCESS_ARTICLE_ARTICLE_ASSIGNMENT = 'SUCCESS_ARTICLE_ARTICLE_ASSIGNMENT';
export const FAILURE_ARTICLE_ARTICLE_ASSIGNMENT = 'FAILURE_ARTICLE_ARTICLE_ASSIGNMENT';

export const fetchArticleArticleAssignment = (articleId: string) =>
    action(FETCH_ARTICLE_ARTICLE_ASSIGNMENT, { articleId });
export const requestArticleArticleAssignment = () => action(REQUEST_ARTICLE_ARTICLE_ASSIGNMENT);
export const requestArticleArticleAssignmentSuccess = (response: any) =>
    action(SUCCESS_ARTICLE_ARTICLE_ASSIGNMENT, { response });
export const requestArticleArticleAssignmentFailure = (error: any) =>
    action(FAILURE_ARTICLE_ARTICLE_ASSIGNMENT, { error });

export const DELETE_ARTICLE_ARTICLE_ASSIGNMENT = 'DELETE_ARTICLE_ARTICLE_ASSIGNMENT';
export const REQUEST_DELETE_ARTICLE_ARTICLE_ASSIGNMENT = 'REQUEST_DELETE_ARTICLE_ARTICLE_ASSIGNMENT';
export const SUCCESS_DELETE_ARTICLE_ARTICLE_ASSIGNMENT = 'SUCCESS_DELETE_ARTICLE_ARTICLE_ASSIGNMENT';
export const FAILURE_DELETE_ARTICLE_ARTICLE_ASSIGNMENT = 'FAILURE_DELETE_ARTICLE_ARTICLE_ASSIGNMENT';

export const deleteArticleArticleAssignment = (articleAssignmentId: string) =>
    action(DELETE_ARTICLE_ARTICLE_ASSIGNMENT, { articleAssignmentId });
export const requestDeleteArticleArticleAssignment = () => action(REQUEST_DELETE_ARTICLE_ARTICLE_ASSIGNMENT);
export const requestDeleteArticleArticleAssignmentSuccess = (response: any) =>
    action(SUCCESS_DELETE_ARTICLE_ARTICLE_ASSIGNMENT, { response });
export const requestDeleteArticleArticleAssignmentFailure = (error: any) =>
    action(FAILURE_DELETE_ARTICLE_ARTICLE_ASSIGNMENT, { error });

/* Article - Article Property */
export const FETCH_ARTICLE_ARTICLE_PROPERTY = 'FETCH_ARTICLE_ARTICLE_PROPERTY';
export const REQUEST_ARTICLE_ARTICLE_PROPERTY = 'REQUEST_ARTICLE_ARTICLE_PROPERTY';
export const SUCCESS_ARTICLE_ARTICLE_PROPERTY = 'SUCCESS_ARTICLE_ARTICLE_PROPERTY';
export const FAILURE_ARTICLE_ARTICLE_PROPERTY = 'FAILURE_ARTICLE_ARTICLE_PROPERTY';

export const fetchArticleArticleProperty = (articleId: string) => action(FETCH_ARTICLE_ARTICLE_PROPERTY, { articleId });
export const requestArticleArticleProperty = () => action(REQUEST_ARTICLE_ARTICLE_PROPERTY);
export const requestArticleArticlePropertySuccess = (response: any) =>
    action(SUCCESS_ARTICLE_ARTICLE_PROPERTY, { response });
export const requestArticleArticlePropertyFailure = (error: any) => action(FAILURE_ARTICLE_ARTICLE_PROPERTY, { error });

/* Article - Article CustomField */
export const FETCH_ARTICLE_ARTICLE_CUSTOM_FIELD = 'FETCH_ARTICLE_ARTICLE_CUSTOM_FIELD';
export const REQUEST_ARTICLE_ARTICLE_CUSTOM_FIELD = 'REQUEST_ARTICLE_ARTICLE_CUSTOM_FIELD';
export const SUCCESS_ARTICLE_ARTICLE_CUSTOM_FIELD = 'SUCCESS_ARTICLE_ARTICLE_CUSTOM_FIELD';
export const FAILURE_ARTICLE_ARTICLE_CUSTOM_FIELD = 'FAILURE_ARTICLE_ARTICLE_CUSTOM_FIELD';

export const fetchArticleArticleCustomField = (articleId: string) =>
    action(FETCH_ARTICLE_ARTICLE_CUSTOM_FIELD, { articleId });
export const requestArticleArticleCustomField = () => action(REQUEST_ARTICLE_ARTICLE_CUSTOM_FIELD);
export const requestArticleArticleCustomFieldSuccess = (response: any) =>
    action(SUCCESS_ARTICLE_ARTICLE_CUSTOM_FIELD, { response });
export const requestArticleArticleCustomFieldFailure = (error: any) =>
    action(FAILURE_ARTICLE_ARTICLE_CUSTOM_FIELD, { error });

/* Article - Article Image */
export const FETCH_ARTICLE_ARTICLE_IMAGE = 'FETCH_ARTICLE_ARTICLE_IMAGE';
export const REQUEST_ARTICLE_ARTICLE_IMAGE = 'REQUEST_ARTICLE_ARTICLE_IMAGE';
export const SUCCESS_ARTICLE_ARTICLE_IMAGE = 'SUCCESS_ARTICLE_ARTICLE_IMAGE';
export const FAILURE_ARTICLE_ARTICLE_IMAGE = 'FAILURE_ARTICLE_ARTICLE_IMAGE';

export const fetchArticleArticleImage = (articleId: string) => action(FETCH_ARTICLE_ARTICLE_IMAGE, { articleId });
export const requestArticleArticleImage = () => action(REQUEST_ARTICLE_ARTICLE_IMAGE);
export const requestArticleArticleImageSuccess = (response: any) => action(SUCCESS_ARTICLE_ARTICLE_IMAGE, { response });
export const requestArticleArticleImageFailure = (error: any) => action(FAILURE_ARTICLE_ARTICLE_IMAGE, { error });

export const UPLOAD_ARTICLE_ARTICLE_IMAGE = 'UPLOAD_ARTICLE_ARTICLE_IMAGE';
export const REQUEST_UPLOAD_ARTICLE_ARTICLE_IMAGE = 'REQUEST_UPLOAD_ARTICLE_ARTICLE_IMAGE';
export const SUCCESS_UPLOAD_ARTICLE_ARTICLE_IMAGE = 'SUCCESS_UPLOAD_ARTICLE_ARTICLE_IMAGE';
export const FAILURE_UPLOAD_ARTICLE_ARTICLE_IMAGE = 'FAILURE_UPLOAD_ARTICLE_ARTICLE_IMAGE';

export const uploadArticleArticleImage = (articleImageInsertRequestDto: RequestArticleImage, uploadFile: any) =>
    action(UPLOAD_ARTICLE_ARTICLE_IMAGE, { articleImageInsertRequestDto, uploadFile });
export const requestUploadArticleArticleImage = () => action(REQUEST_UPLOAD_ARTICLE_ARTICLE_IMAGE);
export const requestUploadArticleArticleImageSuccess = (response: any) =>
    action(SUCCESS_UPLOAD_ARTICLE_ARTICLE_IMAGE, { response });
export const requestUploadArticleArticleImageFailure = (error: any) =>
    action(FAILURE_UPLOAD_ARTICLE_ARTICLE_IMAGE, { error });

export const UPDATE_ARTICLE_ARTICLE_IMAGE = 'UPDATE_ARTICLE_ARTICLE_IMAGE';
export const REQUEST_UPDATE_ARTICLE_ARTICLE_IMAGE = 'REQUEST_UPDATE_ARTICLE_ARTICLE_IMAGE';
export const SUCCESS_UPDATE_ARTICLE_ARTICLE_IMAGE = 'SUCCESS_UPDATE_ARTICLE_ARTICLE_IMAGE';
export const FAILURE_UPDATE_ARTICLE_ARTICLE_IMAGE = 'FAILURE_UPDATE_ARTICLE_ARTICLE_IMAGE';

export const updateArticleArticleImage = (articleImageUpdateRequestDto: RequestArticleImage) =>
    action(UPDATE_ARTICLE_ARTICLE_IMAGE, { articleImageUpdateRequestDto });
export const requestUpdateArticleArticleImage = () => action(REQUEST_UPDATE_ARTICLE_ARTICLE_IMAGE);
export const requestUpdateArticleArticleImageSuccess = (response: any) =>
    action(SUCCESS_UPDATE_ARTICLE_ARTICLE_IMAGE, { response });
export const requestUpdateArticleArticleImageFailure = (error: any) =>
    action(FAILURE_UPDATE_ARTICLE_ARTICLE_IMAGE, { error });

export const DELETE_ARTICLE_ARTICLE_IMAGE = 'DELETE_ARTICLE_ARTICLE_IMAGE';
export const REQUEST_DELETE_ARTICLE_ARTICLE_IMAGE = 'REQUEST_DELETE_ARTICLE_ARTICLE_IMAGE';
export const SUCCESS_DELETE_ARTICLE_ARTICLE_IMAGE = 'SUCCESS_DELETE_ARTICLE_ARTICLE_IMAGE';
export const FAILURE_DELETE_ARTICLE_ARTICLE_IMAGE = 'FAILURE_DELETE_ARTICLE_ARTICLE_IMAGE';

export const deleteArticleArticleImage = (articleImageId: string) =>
    action(DELETE_ARTICLE_ARTICLE_IMAGE, { articleImageId });
export const requestDeleteArticleArticleImage = () => action(REQUEST_DELETE_ARTICLE_ARTICLE_IMAGE);
export const requestDeleteArticleArticleImageSuccess = (response: any) =>
    action(SUCCESS_DELETE_ARTICLE_ARTICLE_IMAGE, { response });
export const requestDeleteArticleArticleImageFailure = (error: any) =>
    action(FAILURE_DELETE_ARTICLE_ARTICLE_IMAGE, { error });

/* Article - ArticleProductGroup */
export const FETCH_ARTICLE_ARTICLE_PRODUCT_GROUP = 'FETCH_ARTICLE_ARTICLE_PRODUCT_GROUP';
export const REQUEST_ARTICLE_ARTICLE_PRODUCT_GROUP = 'REQUEST_ARTICLE_ARTICLE_PRODUCT_GROUP';
export const SUCCESS_ARTICLE_ARTICLE_PRODUCT_GROUP = 'SUCCESS_ARTICLE_ARTICLE_PRODUCT_GROUP';
export const FAILURE_ARTICLE_ARTICLE_PRODUCT_GROUP = 'FAILURE_ARTICLE_ARTICLE_PRODUCT_GROUP';

export const fetchArticleArticleProductGroup = (articleId?: string, productGroupId?: string) =>
    action(FETCH_ARTICLE_ARTICLE_PRODUCT_GROUP, { articleId, productGroupId });
export const requestArticleArticleProductGroup = () => action(REQUEST_ARTICLE_ARTICLE_PRODUCT_GROUP);
export const requestArticleArticleProductGroupSuccess = (response: any) =>
    action(SUCCESS_ARTICLE_ARTICLE_PRODUCT_GROUP, { response });
export const requestArticleArticleProductGroupFailure = (error: any) =>
    action(FAILURE_ARTICLE_ARTICLE_PRODUCT_GROUP, { error });

export const CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP = 'CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP';
export const REQUEST_CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP = 'REQUEST_CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP';
export const SUCCESS_CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP = 'SUCCESS_CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP';
export const FAILURE_CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP = 'FAILURE_CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP';

export const createNewArticleArticleProductGroup = (articleProductGroup: VendorArticleProductGroup) =>
    action(CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP, { articleProductGroup });
export const requestCreateNewArticleArticleProductGroup = () =>
    action(REQUEST_CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP);
export const requestCreateNewArticleArticleProductGroupSuccess = (response: any) =>
    action(SUCCESS_CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP, { response });
export const requestCreateNewArticleArticleProductGroupFailure = (error: any) =>
    action(FAILURE_CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP, { error });

export const UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP = 'UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP';
export const REQUEST_UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP = 'REQUEST_UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP';
export const SUCCESS_UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP = 'SUCCESS_UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP';
export const FAILURE_UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP = 'FAILURE_UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP';

export const updateArticleArticleProductGroup = (articleProductGroup: VendorArticleProductGroup) =>
    action(UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP, { articleProductGroup });
export const requestUpdateArticleArticleProductGroup = () => action(REQUEST_UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP);
export const requestUpdateArticleArticleProductGroupSuccess = (response: any) =>
    action(SUCCESS_UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP, { response });
export const requestUpdateArticleArticleProductGroupFailure = (error: any) =>
    action(FAILURE_UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP, { error });

export const DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP = 'DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP';
export const REQUEST_DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP = 'REQUEST_DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP';
export const SUCCESS_DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP = 'SUCCESS_DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP';
export const FAILURE_DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP = 'FAILURE_DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP';

export const deleteArticleArticleProductGroup = (articleProductGroup: VendorArticleProductGroup) =>
    action(DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP, { articleProductGroup });
export const requestDeleteArticleArticleProductGroup = () => action(REQUEST_DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP);
export const requestDeleteArticleArticleProductGroupSuccess = (response: any) =>
    action(SUCCESS_DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP, { response });
export const requestDeleteArticleArticleProductGroupFailure = (error: any) =>
    action(FAILURE_DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP, { error });
